<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <router-link to="testing">单词训练</router-link>
      <span>></span>
      <span @click="tiaozhuan_wjc">上传闪卡</span>
      <span>></span>
      <router-link to>新建闪卡</router-link>
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">新建闪卡</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          您所上传制作的闪卡练习可进行单词输入及图片、音频的上传，上传图片、音频后需要点击确认导入按钮才可保存！
        </div>
        <div class="form_1 right kbfm">
          <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
            <el-form-item label="闪卡名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input v-model="form.name" placeholder="" class="shanka_mingcheng" disabled></el-input>
            </el-form-item>

            <el-form-item label="上传单词" prop="words" class="shangchuan_lbt sc_danci chuan_dzt">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input class="shanka_w" type="textarea" v-model="form.words" placeholder="clever # 聪明的
college # 大学
curriculum # 课程"></el-input>
              <span class="genghuan_gnk lbt_span1">
                ( 英语 + “#号" + 汉语进行输入 )
              </span>
            </el-form-item>

            <el-form-item class="shangchuan_lbt chuan_dzt" label="上传图片" prop="picurl">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <div class=" duozhan_yin duozhang_tu scrollbarStyle" style="height: 14.01042vw; overflow: auto">
                <el-upload class="ml-20 mt-20 xuigai_yin" action="#" accept="image/png,image/jpg,image/jpeg" multiple :limit="20"
                  :auto-upload="false" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemoveImage"
                  :on-change="handleChangeImage" :file-list="fileListImage">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <span class="genghuan_gnk lbt_span1">
                (
                您可批量上传图片，最多一次上传15张、并且每张大小不可超过1MB，系统将为您按照您上传的顺序进行排列，或您也可以到修改页面修改单个图片.
                )
              </span>
            </el-form-item>

            <el-form-item class="shangchuan_lbt chuan_dzt" label="上传音频">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <div class=" duozhang_tu duozhan_yin scrollbarStyle" style="height: 14.01042vw; overflow: auto">
                <el-upload class="ml-20 mt-50 xuigai_yin" action="#" multiple :limit="20" :auto-upload="false"
                  :on-remove="handleRemoveAudio" :on-change="handleChangeAudio" :file-list="fileListAudio">
                  <el-button size="small" type="primary">选择音频</el-button>
                </el-upload>
              </div>
              <span class="genghuan_gnk lbt_span1">
                (
                您可批量上传音频，最多一次上传15个、并且每个大小不可超过100MB，系统将为您按照您上传的顺序进行排列，或您也可以到修改页面修改单个音频.
                )
              </span>
            </el-form-item>

            <el-form-item class="tijiao">
              <el-button type="primary" @click="submitData">
                保存
              </el-button>
              <el-button @click="addWordPracticeRes1">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { $debounce } from '@/utils/index';
export default {
  name: 'testingDubList',
  data() {
    return {
      FormRules: {},
      fileListImage: [],
      fileListAudio: [],
      form: {
        name: '',
        words: '',
      },
      dialogVisible: false,
      dialogImageUrl: '',
      images: [],
      audios: [],
      banji_id: {},
      banji_ids: {},
      audio_yin: '',
    };
  },
  created() {
    if (!this.$store.state.testingear) {
      this.$router.push({ name: 'testingear' });
      return this.$message.error('您当前的配音页面获取失败！');
    }
    this.banji_id = this.$store.state.testingear;
    this.banji_ids = this.$store.state.testingears;

    this.getWordPracticeById();
  },
  destroyed() {
    localStorage.removeItem('testingear');
    localStorage.removeItem('testingears');
  },
  watch: {},
  methods: {
    submitData: $debounce(function () {
      if (this.form.words === '') {
        return this.$message.error('请输入单词！');
      }
      if (this.fileListImage.length === 0) {
        return this.$message.error('请上传图片！');
      }
      if (this.fileListAudio.length === 0) {
        return this.$message.error('请上传音频！');
      }
      this.uploadPhotos();
    }, 500),
    // 闪卡保存
    addWordPracticeRes0() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/addWordPracticeRes',
        method: 'POST',
        data: {
          id: this.banji_id,
          words: this.form.words,
          images: this.images,
          audios: this.audios,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$store.commit('testing', this.banji_ids);
          this.$router.push({ name: 'testingear' });
          return this.$message.success('闪卡保存成功!');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('闪卡保存失败：' + err);
        });
    },
    // 上传图片
    handleChangeImage(file, fileListImage) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        fileListImage.forEach((v, i) => {
          if (file.uid === v.uid) {
            fileListImage.splice(i, 1);
          }
        });
        return false;
      }
      let existFile = fileListImage.slice(0, fileListImage.length - 1).find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error('当前文件已经存在!');
        fileListImage.pop();
      }
      this.fileListImage = fileListImage;
      console.log(this.fileListImage);
    },
    // 删除图片
    handleRemoveImage(file, fileListImage) {
      this.fileListImage = fileListImage;
      // console.log(fileListImage)
      //   this.formData = new FormData();
      //   for (var i = 0; i < fileListImage.length; i++) {
      //     this.formData.append('files', fileListImage[i].raw);
      //   }
      // this.$message.success('删除成功!')
    },
    // 上传音频
    handleChangeAudio(file, fileListAudio) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        fileListAudio.forEach((v, i) => {
          if (file.uid === v.uid) {
            fileListAudio.splice(i, 1);
          }
        });
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        fileListAudio.forEach((v, i) => {
          if (file.uid === v.uid) {
            fileListAudio.splice(i, 1);
          }
        });
        return false;
      }
      let existFile = fileListAudio.slice(0, fileListAudio.length - 1).find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error('当前文件已经存在!');
        fileListAudio.pop();
      }
      this.fileListAudio = fileListAudio;
    },
    // 删除音频
    handleRemoveAudio(file, fileListAudio) {
      this.fileListAudio = fileListAudio;
    },
    // 查看大图
    handlePictureCardPreview(file) {
      // console.log('file url=' + file.url)
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    tiaozhuan_wjc() {
      this.$store.commit('testing', this.banji_ids);
      this.$router.push({ name: 'testingear' });
    },
    // 上传图片调用接口
    uploadPhotos() {
      let imgList = new FormData();
      this.fileListImage.forEach((v) => {
        imgList.append('files', v.raw);
      });
      let orgid = window.sessionStorage.getItem('orgid');
      imgList.set('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadMultipleImage',
        method: 'POST',
        data: imgList,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.images = result.data.data;
          this.uploadAudio();
        })
        .catch((err) => {
          this.$message.error('系统错误：' + err);
        });
    },
    // 上传音频调用接口
    uploadAudio() {
      console.log(this.fileListAudio);
      let fileAudio = new FormData();
      this.fileListAudio.forEach((v) => {
        fileAudio.append('audiofiles', v.raw);
      });
      let orgid = window.sessionStorage.getItem('orgid');
      fileAudio.set('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadMultipleAudio',
        method: 'POST',
        data: fileAudio,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.audios = result.data.data.ids;
          this.addWordPracticeRes0();
        })
        .catch((err) => {
          this.$message.error('系统错误：' + err);
        });
    },

    addWordPracticeRes1() {
      this.$store.commit('testing', this.banji_ids);
      this.$router.push({ name: 'testingear' });
    },

    // 查询页面信息
    getWordPracticeById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/getWordPracticeById/' + this.banji_id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.form.name = result.data.data.title;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询页面信息失败：' + err);
        });
    },
  },
};
</script>

<style lang="less">
</style>
